"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-thirteen/sections/brandSection.tsx */

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, ReactNode } from "react";

type HomeThirteenBrandSectionBrandsItem = {
    /** Detected variants: "assets/img/company/company-thirteen-1.svg" | "assets/img/company/company-thirteen-2.svg" | "assets/img/company/company-thirteen-3.svg" | "assets/img/company/company-thirteen-4.svg" | "assets/img/company/company-thirteen-5.svg" | "assets/img/company/company-thirteen-6.svg" | "assets/img/company/company-thirteen-7.svg" */
    src: string;
    /** Detected variants: "assets/img/company/company-thirteen-1.svg" | "assets/img/company/company-thirteen-2.svg" | "assets/img/company/company-thirteen-3.svg" | "assets/img/company/company-thirteen-4.svg" | "assets/img/company/company-thirteen-5.svg" | "assets/img/company/company-thirteen-6.svg" | "assets/img/company/company-thirteen-7.svg" */
    text: string;
    /** Detected variants: "company" */
    alt?: string;
};
export type HomeThirteenBrandSectionGeneratedProps = {
    brands?: HomeThirteenBrandSectionBrandsItem[];
    /** Default: "Shop By Brand" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "#" */
    sectionDiv0Div0Link0LinkHref?: string;
    /** Default: "View All" */
    sectionDiv0Div0Link0LinkText?: ReactNode;
    sectionDiv0Div0Link0LinkVisible?: boolean;
    sectionDiv0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    sectionDiv0Swiper0SwiperProps?: Partial<ComponentProps<typeof Swiper>>;
};

const HomeThirteenBrandSectionGenerated: FC<HomeThirteenBrandSectionGeneratedProps> = ({
    brands = [],
    sectionDiv0Div0H20H2Text = "Shop By Brand",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0Link0LinkHref = "#",
    sectionDiv0Div0Link0LinkText = "View All",
    sectionDiv0Div0Link0LinkVisible,
    sectionDiv0Div0Link0LinkRenderer,
    sectionDiv0Div0Link0LinkProps,
    sectionDiv0Swiper0SwiperProps,
}) => {
    return (
        <section className="brands-section-thirteen section pt-0">
            <div className="container">
                <div className="section-header section-header-thirteen">
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>{sectionDiv0Div0H20H2Text}</h2>
                    ))}
                    {renderNode(sectionDiv0Div0Link0LinkVisible, sectionDiv0Div0Link0LinkRenderer, (
                        <SmartLink href={sectionDiv0Div0Link0LinkHref} className="btn theme-12-btn" {...(sectionDiv0Div0Link0LinkProps ?? {})}>
                            {sectionDiv0Div0Link0LinkText}
                            <i className="isax isax-arrow-right-1 ms-2" />
                        </SmartLink>
                    ))}
                </div>
                <Swiper modules={[Autoplay]} loop={true} speed={2000} autoplay={{
                    delay: 0,
                    disableOnInteraction: false,
                }} slidesPerView={6} spaceBetween={0} breakpoints={{
                    1400: { slidesPerView: 6 },
                    1200: { slidesPerView: 6 },
                    992: { slidesPerView: 5 },
                    768: { slidesPerView: 4 },
                    0: { slidesPerView: 3 }
                }} className="company-slider" {...(sectionDiv0Swiper0SwiperProps ?? {})}>
                    {brands.map((src, i) => (
                        <SwiperSlide key={i} className="slide-item">
                            <div className="imgs">
                                <SmartImage src={src.src} alt={src.alt ?? "company"} className="img-fluid img-1" />
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </section>
    );
};

export default HomeThirteenBrandSectionGenerated;
